import { render } from "./ImagePeviewModal.vue?vue&type=template&id=08d146ca&scoped=true&ts=true&lang=pug"
import script from "./ImagePeviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagePeviewModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImagePeviewModal.vue?vue&type=style&index=0&id=08d146ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d146ca"]])

export default __exports__